import { IContentMessages } from 'legacy/lut/components/widgets/public/partnerDuplicates/models'

import { IPartner, IPartnerDuplicate } from 'clickNgo/entities/partner/models'
import { InfoBlock, InfoBlockSize } from 'cng-common/components/infoBlock'

import { filterContent } from '../helpers/filterContent'

import styles from './PartnerDuplicatesContentMessages.module.scss'

interface IPartnerDuplicatesContentMessagesProps extends IContentMessages {
  partner: IPartner
  searchResult: IPartnerDuplicate
}

export const PartnerDuplicatesContentMessages = ({
  contentMessages = [],
  partner,
  searchResult,
}: IPartnerDuplicatesContentMessagesProps) => {
  const filterFn = filterContent(partner, searchResult)
  return (
    <div className={styles.messages}>
      {contentMessages.filter(filterFn).map((message, key) => (
        <InfoBlock
          key={key}
          text={message.message}
          type={message.type}
          paddingSize={InfoBlockSize.Small}
        />
      ))}
    </div>
  )
}
